module.exports = __webpack_public_path__ + "static/img/team3.6b7d62c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/instructors/team3.jpg
// module id = OnNl
// module chunks = 1